<template>
    <div>
        <div class="content-wrapper" style="padding-bottom: 0">
            <app-breadcrumb :page-title="data.name" :icon="'package'"/>
            <div><b>{{ $t('league_id') }}: </b>{{ data.id }}</div>
        </div>
        <pinnacle-leagues-datatable :league_id='data.id'></pinnacle-leagues-datatable>
    </div>
</template>

<script>
    import * as actions from "../../../../Config/ApiUrl";
    import {urlGenerator} from "../../../../Helpers/AxiosHelper";

    export default {
        name: "ViewLeague",
        props: ['data'],
        data() {
            return {
                componentLoader: false,
                preloader: false,
            }
        },
    }
</script>